import HeaderComponent from "../../components/Header";
import axios from "axios";
import Image from "next/image";
import NavigationComponent from "../../components/HeaderNavigation";
import ProfileLayout from "../../components/ProfileLayout";
import { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useSession } from "next-auth/react";
import { toBackend } from "../../utilities/requestsTypes";

export default function Home() {
  const [tabValue, setTabValue] = useState("swap-requests");
  const [loginState, setLoginState] = useState(false);
  const [allSwapRequests, setAllSwapRequests] = useState([]);
  const [allSentRequests, setAllSentRequests] = useState([]);

  const {data: session} = useSession();


  const getSwapRequest = async  () => {
    try {
      const res = await toBackend.get("swap-request/swap-requests", {
        headers: {
            accesstoken: session.user.token
        }
      });
      if(res.status == 200) {
        setAllSwapRequests(res.data);
        console.log(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const getSentRequest = async () => {
    try {
      const res = await toBackend.get("swap-request/sent-requests", {
        headers: {
            accesstoken: session.user.token,
        }
      });
      if(res.status == 200) {
        setAllSentRequests(res.data);
        console.log(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getSwapRequest();
    getSentRequest();
  }, []);

  const swapRequests = [
    {
      _id: "1",
      ownerId: "11",
      swapRequesterId: "111",
      ownerProductId: "1111",
      productToSwapId: "11111",
      productSwapState: "pending",
      productWriteup:
        "Jerry Lee want to swap your Gionee phone for iphone 6s plus",
    },
    {
      _id: "2",
      ownerId: "22",
      swapRequesterId: "222",
      ownerProductId: "2222",
      productToSwapId: "22222",
      productSwapState: "pending",
      productWriteup:
        "Jerry Lee want to swap your armed chair for 12,000 naira",
      edited: true,
    },
    {
      _id: "2",
      ownerId: "22",
      swapRequesterId: "222",
      ownerProductId: "2222",
      productToSwapId: "22222",
      productSwapState: "accepted",
      productWriteup:
        "Jerry Lee want to swap your Gionee phone for iphone 6s plus",
      edited: true,
    },
    {
      _id: "2",
      ownerId: "22",
      swapRequesterId: "222",
      ownerProductId: "2222",
      productToSwapId: "22222",
      productSwapState: "declined",
      productWriteup:
        "Jerry Lee want to swap your Gionee phone for iphone 6s plus",
      edited: false,
    },
  ];

  const sentRequests = [
    {
      _id: "1",
      writeUp: "You requested to swap your Laptop with Mary’s Phone",
      requestState: "accepted",
    },
    {
      _id: "2",
      writeUp: "You requested to swap your Laptop with Mary’s Phone",
      requestState: "pending",
    },
    {
      _id: "3",
      writeUp: "You requested to swap your Laptop with Mary’s Phone",
      requestState: "declined",
    },
    {
      _id: "4",
      writeUp: "You requested to swap your Laptop with Mary’s Phone",
      requestState: "pending",
    },
  ];

  return (
    <div className="overflow-hidden h-full">
      <ToastContainer />
      <HeaderComponent />

      <hr />

      <NavigationComponent />

      <hr />

      <ProfileLayout>
        <div className="w-full flex gap-x-8 p-8 justify-center">
          <button
            className={
              tabValue == "swap-requests"
                ? "text-[#262626] self-start"
                : "text-[#808080] self-start"
            }
            onClick={() => {
              setTabValue("swap-requests");
            }}
          >
            Swap Requests
            <div
              className={
                tabValue == "swap-requests"
                  ? "w-[60px] h-[4px] bg-[#FFC300] mx-auto mt-2"
                  : "hidden"
              }
            ></div>
          </button>
          <button
            className={
              tabValue == "sent-requests"
                ? "text-[#262626] self-start"
                : "text-[#808080] self-start"
            }
            onClick={() => {
              setTabValue("sent-requests");
            }}
          >
            Sent Requests
            <div
              className={
                tabValue == "sent-requests"
                  ? "w-[60px] h-[4px] bg-[#FFC300] mx-auto mt-2"
                  : "hidden"
              }
            ></div>
          </button>
        </div>

        <div
          className={`p-2 ${
            tabValue == "swap-requests" ? "flex" : " hidden"
          }`}
        >
            <div className="flex flex-col gap-4 mx-auto">
              {allSwapRequests.length == 0 ? "No Requests" : ""}
          {allSwapRequests.map((swapRequest, index) => {
            return (
              <div className={"flex gap-2 w-[750px]"} key={index}>
                <div
                  className={`h-[80px] w-[80px] rounded-full overflow-hidden`}>
                  <Image
                    src={`/images/img2.png`}
                    alt='none'
                    height="20"
                    width="20"
                    layout="responsive"
                  />
                </div>
                <div className="flex flex-col justify-center">
                  <div className="w-[500px]">{swapRequest.productWriteup}</div>
                  <div
                    className={`gap-x-4 flex-right ${
                      swapRequest.productSwapState == "pending"
                        ? "flex"
                        : "hidden"
                    }`}
                  >
                    <button className=" px-8 py-2 text-white bg-primary rounded-[10px]">
                      Accept
                    </button>
                    <button className=" px-8 py-2 text-black bg-[#D9D9D9] rounded-[10px]">
                      Decline
                    </button>
                  </div>
                  <div
                    className={
                      swapRequest.productSwapState == "accepted" ||
                      swapRequest.productSwapState == "declined"
                        ? "block"
                        : "hidden"
                    }
                  >
                    <div
                      className={`inline-block px-4 rounded-[10px] py-2 bg-[#D9D9D9] text-[#808080] ${
                        swapRequest.productSwapState == "accepted"
                          ? "block"
                          : "hidden"
                      }`}
                    >
                      Request Accepted
                    </div>
                    <div
                      className={`inline-block px-4 rounded-[10px] py-2 bg-[#D9D9D9] text-[#808080] ${
                        swapRequest.productSwapState == "declined"
                          ? "block"
                          : "hidden"
                      }`}
                    >
                      Request Declined
                    </div>
                  </div>
                </div>
                <div
                  className={swapRequest.edited == true ? "block" : "hidden"}
                >
                  <div className="h-[40px] w-[40px] mx-auto rounded-full overflow-hidden">
                    <Image
                      src={`/images/apple.png`}
                      alt='none'
                      height="200"
                      width="200"
                      layout="intrinsic"
                    />
                  </div>
                  <button>View Change</button>
                </div>
              </div>
            );
          })}
            </div>
        </div>
        <div
            className={`p-2 ${
              tabValue == "sent-requests" ? "flex" : "hidden"
            }`}>

            <div className=" flex flex-col gap-4 mx-auto">
            {allSentRequests.length == 0 ? "No Requests" : ""}
            {allSentRequests.map((sentRequest, index) => {
              return (
                <div className={`flex items-center gap-x-4 w-[750px]`} key={index}>
                  <div
                    className={`h-[80px] w-[80px] rounded-full overflow-hidden ${
                      sentRequest.edited == true ? "ml-[100px]" : ""
                    }`}
                  >
                    <Image
                      src={`/images/img2.png`}
                      alt='none'
                      height="20"
                      width="20"
                      layout="responsive"
                    />
                  </div>

                  <div className="w-[500px]">You requested to swap {sentRequest.productId.name} with {sentRequest.productOwnerId.fullName} {sentRequest.swapFor == "for-goods" ? "For Goods" : "For Their Product"}</div>

                    <div>
                  <div
                    className={`text-[#001D3D] ${
                      sentRequest.swapRequestState == "pending" ? "block" : "hidden"
                    }`}
                  >
                    Pending
                  </div>
                  <div
                    className={`text-[#808080] ${
                      sentRequest.requestState == "accepted"
                        ? "block"
                        : "hidden"
                    }`}
                  >
                    Request Accepted
                  </div>
                  <div
                    className={`text-[#808080] ${
                      sentRequest.requestState == "declined"
                        ? "block"
                        : "hidden"
                    }`}
                  >
                    Request Delcined
                  </div>

                    </div>
                </div>
              );
            })}
            </div>

          </div>
      </ProfileLayout>
    </div>
  );
}
